<template>
    <modal v-if="showModal" @close="$emit('closeModal')">
        <template slot="header">
            <h4 class="modal-title">{{title}}</h4>
            <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="$emit('closeModal')">
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <multiselect
                    v-model="selected"
                    deselect-label="Can't remove this value"
                    track-by="name"
                    :multiple="multiple"
                    label="name"
                    placeholder="Select Role to Add"
                    :options="permissions"
                    :searchable="true"
                    :allow-empty="false"
                    >
            </multiselect>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="$emit('addRoles',selected)">Add Selected Role(s)</md-button>
            <md-button
                    class="md-danger md-simple"
                    @click="$emit('closeModal')">Close
            </md-button>
        </template>
    </modal>
</template>

<script>
import {
    Modal
} from '@/components';
import Multiselect from 'vue-multiselect';

export default {
    name: 'AddRoleModal',
    components: { Modal, Multiselect },
    props:{
        title:{
            type:String,default:'Add role'
        },
        showModal:{
            type:Boolean,default: false
        },
        multiple:{
            type:Boolean,default: true
        }
    },
    data () {
        return {
            'permissions':[],
            selected:[]
        };
    },
    created () {
        this.fetchData();
    },
    methods:{
        async fetchData () {
            await this.$store.dispatch('roles/list');
            this.permissions = this.$store.getters['roles/list'];
        }
    }
};
</script>

<style scoped>

</style>
